import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Box } from "@mui/material";
import styled from "styled-components";
import { Error } from "components/error";
import { Controller, useController } from "react-hook-form";
import { withErrorBoundary } from "react-error-boundary";
import { ErrorComponent } from "components/common";
const InputDatePickerStyled = styled.div`
	.MuiBox-root {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		border-bottom: 1px solid #94bcdc;
	}
	.MuiSvgIcon-root {
		font-size: 1rem;
	}
	.css-1laqsz7-MuiInputAdornment-root {
		max-height: 1em;
	}
	input {
		flex: 1;
		font-size: 0.729rem;
	}
`;
const InputDatePicker = ({
	control,
	name,
	disabled,
	label,
	setValueData,
	error = {},
}) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, value } }) => (
					<DatePicker
						value={value}
						disabled={!!disabled}
						onChange={onChange}
						className="pms-input-datepicker"
						renderInput={({ inputRef, inputProps, InputProps }) => (
							<InputDatePickerStyled className="form-group pms-datepicker ">
								<label
									className="text-sm cursor-pointer"
									htmlFor={name}>
									{label}
								</label>
								<div className={`wrap-datepicker flex items-center justify-between pb-2 pt-1 border-b-[#94BCDC] border-b ${disabled && 'disabled'}`}>
									<input
										ref={inputRef}
										{...inputProps}
										name={name}
										id={name}
									/>
									{InputProps?.endAdornment}
								</div>
								{error && <Error>{error[name]?.message}</Error>}
							</InputDatePickerStyled>
						)}
					/>
				)}
			/>
		</LocalizationProvider>
	);
};

export default withErrorBoundary(InputDatePicker, {
	FallbackComponent: ErrorComponent,
});
